import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AQGray from "../../assets/images/ourClients/aq-gray.png";
import AQColor from "../../assets/images/ourClients/aq-hover.png";
import EnpagosColor from '../../assets/images/ourClients/enpagos-color.webp';
import EnpagosGray from '../../assets/images/ourClients/enpagos-gray.webp';
import FortradeGray from "../../assets/images/ourClients/fortrade-gray.png";
import FortradeColor from "../../assets/images/ourClients/fortrade-hover.png";
import KluColor from '../../assets/images/ourClients/klu-color.png';
import KluGray from '../../assets/images/ourClients/klu-gray.png';
import PinpeoColor from '../../assets/images/ourClients/pinpeo-color.webp';
import PinpeoGray from '../../assets/images/ourClients/pinpeo-gray.webp';
import SodaCapitalColor from '../../assets/images/ourClients/sodacapital-color.png';
import SodaCapitalGray from '../../assets/images/ourClients/sodacapital-gray.png';
import {
  ContItemClients,
  ContItemsClients,
  ContOurClients,
  TitleOurClients,
} from './OurClients.styles';

const ItemClient = ({imgGray = '', imgColor = '', alt = ''}) => {
  const [client, setClient] = useState(imgGray);

  return (
    <img
      src={client}
      alt={alt}
      width={'100%'} 
      height={'auto'}
      onMouseOver={() => {
        setClient(imgColor);
      }}
      onMouseOut={() => {
        setClient(imgGray);
      }}
    />
  );
};

export const OurClients = () => {
  const { t } = useTranslation();
  return (
    <ContOurClients>
      <div className={'section-first container-fit'}>
        <TitleOurClients>
          {t('Clientes')}
        </TitleOurClients>
        <ContItemsClients id={'ContItemsClients'}>
          <ContItemClients>
            <ItemClient imgGray={AQGray} imgColor={AQColor} alt={'Logo AQ'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={KluGray} imgColor={KluColor} alt={'Logo Citycell'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={FortradeGray} imgColor={FortradeColor} alt={'Logo '}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={EnpagosGray} imgColor={EnpagosColor} alt={'Logo Enpagos'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={PinpeoGray} imgColor={PinpeoColor} alt={'Logo Pinpeo'}/>
          </ContItemClients>
          <ContItemClients>
            <ItemClient imgGray={SodaCapitalGray} imgColor={SodaCapitalColor} alt={'Logo Lespago'}/>
          </ContItemClients>
        </ContItemsClients>
      </div>
    </ContOurClients>
  );
};
